import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 6,
	height: 8,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#3A3A3A",
		d: "M1.27 8 0 6.75 2.794 4 0 1.25 1.27 0l4.063 4L1.27 8Z"
	})]
});
const ForwardRef = forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
